import { render, staticRenderFns } from "./UpcomingShiftList.vue?vue&type=template&id=3ff0f30c&scoped=true&"
import script from "./UpcomingShiftList.vue?vue&type=script&lang=js&"
export * from "./UpcomingShiftList.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingShiftList.vue?vue&type=style&index=0&id=3ff0f30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0f30c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VDivider,VLayout,VList,VListItem,VListItemSubtitle,VListItemTitle,VProgressCircular})
